import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { normalizePortfolioFilter } from "web_myplann/Portfolio/Helpers/normalizePortfolioFilter";
import { useAvailableCategoriesByContractState } from "web_myplann/Portfolio/Hooks/useAvailableCategoriesByContractState";
import type { AvailableCategoriesByContractState } from "web_myplann/Portfolio/Types/AvailableCategoriesByContractState";
import {
	type PortfolioFilterState,
	portfolioFilterState,
} from "web_myplann/Shared/State/portfolioFilterAtom";

type EffectivePortfolioFilter = {
	filter: PortfolioFilterState;
	availableByContractState: AvailableCategoriesByContractState | undefined;
};

export const useEffectivePortfolioFilter = (): EffectivePortfolioFilter => {
	const storedFilter = useAtomValue(portfolioFilterState);
	const availableByContractState = useAvailableCategoriesByContractState();

	const filter = useMemo(
		() => normalizePortfolioFilter(storedFilter, availableByContractState),
		[storedFilter, availableByContractState],
	);

	return { filter, availableByContractState };
};
